import * as React from "react";
const SvgArrowRightBlack = (props) => /* @__PURE__ */ React.createElement("svg", { width: 8, height: 12, viewBox: "0 0 8 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M2 2L6 6L2 10", stroke: "#1D2329", strokeWidth: 2, strokeLinecap: "square" }));
export default SvgArrowRightBlack;
